// animation
import { Fade } from 'react-awesome-reveal';
// import icons
import { WelComeLogo } from 'utils/Icons';

const SplashScreen = ({setActiveStep }) => {
    return (
      <div className="text_white signup_card text_center">
        <div className="step_card_body">
          <Fade triggerOnce delay={800} duration={1200}>
            <WelComeLogo className="mx_auto" />
          </Fade>
          <br />
          <Fade triggerOnce delay={1400} duration={1400}>
            <h3>Welcome, mama…</h3>
          </Fade>
          <br />
          <Fade triggerOnce delay={1950} duration={1500}>
            <p>We get it.</p>
          </Fade>
          <br />
          <Fade triggerOnce delay={2650} duration={1600}>
            <h3>
              Motherhood is really <br /> freakin’ hard!
            </h3>
          </Fade>
          <br />
          <Fade triggerOnce delay={3500} duration={1500}>
            <p>We’re here to help.</p>
          </Fade>
        </div>
  
        <div className="mt_auto screen_sticky_footer">
          <Fade triggerOnce delay={4200} duration={1600}>
            <button onClick={() => setActiveStep(0)} className="cs_btn w_100">
              Continue
            </button>
          </Fade>
        </div>
      </div>
    );
  };

export default SplashScreen